import CssVariables from './css-variables';
import themeColors from './theme.module.scss';
import typographyVariants from './typography';
const defaultTextFieldErrorOverrides = {
    margin: 'unset',
    fontSize: 10,
    textAlign: 'end',
    position: 'absolute',
    right: 0,
    bottom: -14
};
export const themeObj = {
    palette: {
        primary: {
            main: CssVariables.primaryMain,
            dark: CssVariables.primaryDark,
            contrastText: CssVariables.white,
        },
        secondary: {
            main: CssVariables.secondaryMain,
            dark: CssVariables.secondaryDark,
            contrastText: CssVariables.black,
        },
        brand: {
            main: CssVariables.brandMain,
            dark: CssVariables.brandDark,
            contrastText: CssVariables.white
        },
        error: {
            main: CssVariables.errorMain,
            dark: CssVariables.errorDark,
            contrastText: CssVariables.white,
        },
        warning: {
            main: CssVariables.warningMain,
            dark: CssVariables.warningDark,
            contrastText: CssVariables.white
        },
        info: {
            main: CssVariables.infoMain,
            dark: CssVariables.infoDark,
            contrastText: CssVariables.white
        },
        success: {
            main: CssVariables.successMain,
            dark: CssVariables.successDark,
            contrastText: CssVariables.white
        },
        inheritWhite: {
            main: CssVariables.secondaryMain,
            dark: CssVariables.secondaryDark,
            contrastText: CssVariables.white
        },
        green: {
            main: CssVariables.green,
            light: CssVariables.greenLight,
            dark: CssVariables.greenDark,
            contrastText: CssVariables.white,
        },
        orange: {
            main: CssVariables.orange,
            light: CssVariables.orangeLight,
            dark: CssVariables.orangeDark,
            contrastText: CssVariables.white,
        },
        pink: {
            main: CssVariables.pink,
            light: CssVariables.pinkLight,
            dark: CssVariables.pinkDark,
            contrastText: CssVariables.white,
        },
        cyanBlue: {
            main: CssVariables.cyanBlue,
            contrastText: CssVariables.white,
            light: CssVariables.cyanBlueLight,
            dark: CssVariables.cyanBlueDark,
        },
        border: {
            main: CssVariables.borderColor
        }
    },
    typography: Object.assign({ fontFamily: 'Open Sans', fontSize: 14, defaultProps: {
            variant: 'bodyMd'
        } }, typographyVariants),
    shape: {},
    spacing: 8,
    components: {
        MuiCssBaseline: {
            styleOverrides: `
        a {
          color: CssVariables.primaryMain
        }
      `
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                color: 'primary',
                disableElevation: true
            },
            styleOverrides: {
                root: {
                    fontFamily: 'Inter',
                    textTransform: 'none',
                    letterSpacing: '0.46px'
                }
            },
            variants: [
                {
                    props: { variant: 'outlined', color: 'secondary' },
                    style: {
                        color: CssVariables.black,
                        borderColor: CssVariables.secondaryBorderColor,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }
                },
                {
                    props: { variant: 'outlined', color: 'inheritWhite' },
                    style: {
                        color: CssVariables.white,
                        borderColor: CssVariables.white,
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                            borderColor: CssVariables.white
                        }
                    }
                }
            ]
        },
        MuiFormControl: {
            defaultProps: {
                size: 'small'
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                variant: 'outlined',
                InputLabelProps: {
                    style: { color: CssVariables.borderColor }
                },
                InputProps: {},
            },
            styleOverrides: {
                root: {
                    fontSize: 10,
                    '& .MuiFormLabel-root': {
                        color: CssVariables.labelLight,
                    },
                    '& input:-internal-autofill-selected': {
                        'WebkitBoxShadow': '0 0 0px 1000px white inset',
                    },
                    '& .MuiFormHelperText-root.Mui-error': defaultTextFieldErrorOverrides,
                    '&.Mui-success .MuiInputBase-root fieldset': {
                        borderColor: CssVariables.secondaryLight,
                    },
                }
            }
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: defaultTextFieldErrorOverrides
            }
        },
        MuiCheckbox: {
            defaultProps: {
                color: 'primary'
            }
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    cursor: 'pointer'
                }
            }
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    backgroundColor: themeColors.backdropBackground,
                    opacity: '0.3 !important'
                },
                invisible: {
                    opacity: '0 !important'
                }
            }
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    borderRadius: '0px',
                    border: 'none',
                    '& .MuiDataGrid-row.Mui-selected': {
                        backgroundColor: `${themeColors.tableRow} !important`
                    },
                    '& .MuiDataGrid-virtualScrollerContent': {
                        marginTop: '1px'
                    },
                    '& .MuiPaginationItem-page': {
                        borderRadius: '2px',
                        border: `1px solid ${themeColors.medGrey}`,
                        fontSize: '12px',
                        height: '20px',
                        width: '20px',
                        minWidth: '20px'
                    },
                    '& .MuiDataGrid-row:hover': {
                        backgroundColor: themeColors.lightGrey
                    }
                },
                virtualScrollerContent: {
                    marginTop: '0px !important'
                },
                columnHeader: {
                    outline: 'none !important'
                },
                columnHeaders: {
                    backgroundColor: themeColors.columnHeader,
                    borderTopLeftRadius: '0px',
                    borderTopRightRadius: '0px'
                },
                columnHeaderTitle: {
                    color: themeColors.columnHeaderTitle,
                    fontSize: '12px',
                    fontWeight: '600 !important'
                },
                cell: {
                    fontSize: '13px',
                    outline: 'none !important'
                },
                iconButtonContainer: {
                    transactionVisibility: 'visible',
                    width: 'auto'
                },
                columnSeparator: {
                    color: themeColors.blueGrey
                },
                columnHeaderTitleContainer: {
                    justifyContent: 'space-between',
                    paddingRight: '0px',
                    paddingLeft: '0px'
                },
                menuIconButton: {
                    background: 'transparent !important',
                    color: `${themeColors.blueGrey} !important`,
                    visibility: 'visible',
                    '&:hover': {
                        background: 'rgba(0, 0, 0, 0.04) !important'
                    }
                },
                menuIcon: {
                    width: 'auto'
                },
                sortIcon: {
                    background: 'transparent',
                    color: themeColors.blueGrey,
                    opacity: '1 !important'
                }
            }
        }
    },
};
//# sourceMappingURL=theme.js.map